import { useMemo, useState } from 'react'
import { Check, ChevronDown, LayoutGrid, List } from 'lucide-react'
import { ROCKET_STANDARD_SLIDES, rocketStandardSlideGroups } from './rocketStandardSlides'

export function RocketStandardSlidesGallery() {
  const groups = useMemo(() => rocketStandardSlideGroups(), [])
  const [selected, setSelected] = useState<string[]>(() => ROCKET_STANDARD_SLIDES.map((slide) => slide.id))
  const [mode, setMode] = useState<'visual' | 'lista'>('visual')
  const [open, setOpen] = useState(false)
  const total = ROCKET_STANDARD_SLIDES.length

  const toggle = (id: string) => {
    setSelected((current) => (current.includes(id) ? current.filter((item) => item !== id) : [...current, id]))
  }

  return (
    <section className="w-full rounded-xl border border-[var(--glass-border)] bg-[var(--glass-bg)] p-4">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
        className="flex w-full items-center justify-between gap-3 text-left"
      >
        <h4 className="text-xs font-bold uppercase tracking-wider text-accent">Slides da apresentação padrão</h4>
        <span className="flex shrink-0 items-center gap-2">
          <span className="rounded-md bg-white/[0.06] px-2 py-1 text-[11px] font-semibold text-text-primary">
            {selected.length}/{total}
          </span>
          <ChevronDown size={16} className={`text-text-muted transition-transform ${open ? 'rotate-180' : ''}`} />
        </span>
      </button>

      {open && (
      <div className="mt-3">
      <p className="mb-3 text-[10px] leading-relaxed text-text-muted">
        Páginas reais da apresentação Rocket Search. O slide de investimentos continua sendo o último ao baixar a proposta.
      </p>

      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <div className="flex gap-2">
          <button type="button" className="text-[11px] font-semibold text-accent" onClick={() => setSelected(ROCKET_STANDARD_SLIDES.map((slide) => slide.id))}>
            Selecionar todos
          </button>
          <button type="button" className="text-[11px] font-semibold text-text-muted" onClick={() => setSelected([])}>
            Limpar
          </button>
        </div>
        <div className="flex rounded-lg border border-white/[0.08] bg-white/[0.03] p-0.5">
          <button
            type="button"
            onClick={() => setMode('visual')}
            className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-semibold ${mode === 'visual' ? 'bg-accent text-white' : 'text-text-muted'}`}
          >
            <LayoutGrid size={12} /> Visual
          </button>
          <button
            type="button"
            onClick={() => setMode('lista')}
            className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-semibold ${mode === 'lista' ? 'bg-accent text-white' : 'text-text-muted'}`}
          >
            <List size={12} /> Lista
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {groups.map((group) => (
          <div key={group.group}>
            <p className="mb-2 text-[10px] font-bold uppercase tracking-wider text-text-label">{group.group}</p>
            <div className={mode === 'visual' ? 'grid grid-cols-2 gap-3 xl:grid-cols-3' : 'space-y-2'}>
              {group.slides.map((slide) => {
                const active = selected.includes(slide.id)
                return (
                  <button
                    key={slide.id}
                    type="button"
                    aria-pressed={active}
                    onClick={() => toggle(slide.id)}
                    className={`overflow-hidden rounded-xl border text-left transition-colors ${
                      active ? 'border-accent bg-accent/10' : 'border-white/[0.08] bg-white/[0.02]'
                    }`}
                  >
                    {mode === 'visual' ? (
                      <span className="relative block aspect-video bg-black">
                        <img src={slide.image} alt={slide.title} className="h-full w-full object-cover" />
                        <span className="absolute left-2 top-2 flex h-5 min-w-5 items-center justify-center rounded-full bg-black/70 px-1 text-[10px] font-bold text-white">
                          {slide.number}
                        </span>
                        {active && (
                          <span className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-accent text-white">
                            <Check size={12} />
                          </span>
                        )}
                      </span>
                    ) : null}
                    <span className="block px-2 py-2 text-[11px] font-semibold text-text-primary">{slide.title}</span>
                  </button>
                )
              })}
            </div>
          </div>
        ))}
      </div>
      </div>
      )}
    </section>
  )
}
